import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPath, SignUpPath } from "../common/enum/path";
import FindIdAndPasswordPage from "../page/login/FindIdAndPasswordPage";
import LoginPage from "../page/login/LoginPage";
import PasswordUpdate from "../page/login/PasswordUpdatePage";
import SignUpBusinessPage from "../page/signup/SignUpBusinessPage";
import SignUpCorporatePage from "../page/signup/SignUpCorporatePage";
import SignUpPage from "../page/signup/SignUpPage";

export const AuthRouter = () => {
  return (
    <div className="bg-primary-white">
      <Routes>
        <Route path={LoginPath.LOGIN} element={<LoginPage />} />
        <Route
          path={LoginPath.FIND_ID_AND_PASSWORD}
          element={<FindIdAndPasswordPage />}
        />
        <Route
          path={`${LoginPath.FIND_PASSWORD_UPDATE}/:token`}
          element={<PasswordUpdate />}
        />
        <Route path={SignUpPath.SIGN_UP} element={<SignUpPage />} />
        <Route
          path={SignUpPath.SIGN_UP_BUSINESS}
          element={<SignUpBusinessPage />}
        />
        <Route
          path={SignUpPath.SIGN_UP_CORPORATE}
          element={<SignUpCorporatePage />}
        />
        {/* <Route path={"/test"} element={<OrderPDFDownloadButton />} /> */}
        <Route path="*" element={<Navigate to={LoginPath.LOGIN} />} />
      </Routes>
    </div>
  );
};
